export const Breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
} as const;

export type BreakpointTokenType = keyof typeof Breakpoints;

export const BreakpointsPx = {
  xs: `${Breakpoints.xs}px`,
  sm: `${Breakpoints.sm}px`,
  md: `${Breakpoints.md}px`,
  lg: `${Breakpoints.lg}px`,
  xl: `${Breakpoints.xl}px`,
  xxl: `${Breakpoints.xxl}px`,
} as const;

export type BreakpointPxTokenType = keyof typeof BreakpointsPx;
